import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const HoverContainer = styled.div<{ $bg?: string }>`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  background: ${({ $bg }) =>
    $bg || 'linear-gradient(to right, rgba(255, 255, 255, 0) 45%, #fff 60%, #e0e0e0 100%)'};
  cursor: pointer;
  padding-right: 30px;
  ${media.tablet`
    padding-right: 0;
  `}
`;

export const ListItemContainer = styled.article`
  display: flex;
  position: relative;
  padding: 15px 0;
  border-radius: 5px;
  background: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  margin-bottom: 1rem;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: stretch;
  transform: perspective(1px) translateZ(0);
  backface-visibility: hidden;

  &:hover {
    box-shadow: 0 18px 20px 0 ${({ theme }) => theme.black.a2};
    z-index: 1;
    transform: scale(1.02, 1.02) perspective(1px) translateZ(0);

    ${HoverContainer} {
      display: flex;
    }
  }
`;

export const MainContent = styled.div`
  padding: 5px 30px;
  flex: 2 1 auto;
`;

export const TitleBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin: 0;
  > span > a {
    color: ${({ theme }) => theme.baseBlue.a10};
    text-decoration: none;
    &:hover {
      opacity: 1;
    }
  }
`;

export const InfoBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const PropsBox = styled.div`
  display: flex;
  font-size: 1rem;
  line-height: 1.733rem;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.baseBlue.a6};

  > :not(:last-child)::after {
    content: '»';
    padding: 0 0.7rem;
  }
`;

export const HoverBtnBox = styled(({ $hoverColor, $color, ...rest }) => React.createElement(Link, rest))<{
  $hoverColor?: string;
  $color?: string;
}>`
  ${({ theme, $hoverColor, $color = theme.baseBlue.a10 }) => css`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    opacity: 0.65;
    padding-left: 15px;
    padding-right: 15px;
    height: 100%;
    color: ${$color};
    &,
    svg {
      color: ${$color};
    }

    &:hover {
      opacity: 1;
      color: ${$color};
      svg {
        color: ${$hoverColor || $color};
      }
    }

    &.small-btn {
      justify-content: center;
    }

    &.wide-btn {
      flex: 2 1 auto;
      justify-content: flex-end;
      padding-right: 15px;
      padding-left: 0;
    }
  `}
`;

export const HoverText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.733rem;
  text-align: right;
  margin-right: 10px;
`;

export const ToolTipContent = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  white-space: nowrap;
`;

export const SingleItem = styled.span`
  display: flex;
  align-items: center;
  font-weight: 600;
  > div {
    margin-left: 10px;
  }
`;
